import React, { Component } from 'react'
import Gallery from 'react-photo-gallery'
import { fulcrumRequest } from '../../utilities/fulcrum'
import { Modal, Button, Table } from 'antd'
import moment from 'moment'

export default class Photos extends Component {
  state = {
    galleryList: [],
    loaded: false,
    loadedAmount: '0 ',
    modalVisible: false,
    selectedPhoto: {
      src: '',
      img_data: {
        date: '',
        lat: '',
        lng: '',
        original: ''
      }
    }
  }
  componentDidMount() {
    this.createPhotoSourceList(this.props.photoList);
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.photoList !== prevProps.photoList) {
      this.setState({
        galleryList: [],
        selectedPhoto: {
          src: '',
          img_data: {
            date: '',
            lat: '',
            lng: '',
            original: ''
          }
        }
      }, () => {
        this.createPhotoSourceList(this.props.photoList);
      })
    }
  }
  createPhotoSourceList(photoIdList) {
    var processed = 0;

    photoIdList.forEach(photo => {
      fulcrumRequest({ method: 'photo', id: photo.photo_id })
        .then(({ data: photoData }) => {
          this.setState({
            galleryList: [...this.state.galleryList, {
              src: photoData.thumbnail,
              width: photoData.exif.pixel_x_dimension / 10,
              height: photoData.exif.pixel_y_dimension / 10,
              img_data: {
                client_job_number: photo.client_job_number,
                lat: photoData.latitude,
                lng: photoData.longitude,
                date: photoData.created_at,
                original: photoData.original
              }
            }]
          })
        })
        .then(() => {
          processed++
          if (processed === photoIdList.length) {
            this.setState({
              loaded: true
            })
          } else {
            this.setState({
              loadedAmount: `${processed} / ${photoIdList.length}`
            })
          }
        })
        .catch(err => console.log(err))
    })
  }

  openImageData(evt, obj) {
    console.log(obj.photo)
    this.setState({
      selectedPhoto: {
        src: obj.photo.src,
        img_data: {
          client_job_number: obj.photo.img_data.client_job_number,
          date: obj.photo.img_data.date,
          lat: obj.photo.img_data.lat,
          lng: obj.photo.img_data.lng,
          original: obj.photo.img_data.original
        }
      },
      modalVisible: true
    })
  }
  handleOk = (e) => {
    console.log(e);
    this.setState({
      modalVisible: false,
      selectedPhoto: {
        src: '',
        img_data: {
          date: '',
          lat: '',
          lng: '',
          original: ''
        }
      }
    });
  }

  Gallery() {
    if (this.state.galleryList.length !== 0) {
      return (
        <Gallery photos={this.state.galleryList} onClick={(evt, obj) => this.openImageData(evt, obj)} className='image-gallery-slide' />
      )
    } else {
      return null
    }
  }
  loadedStatus(loaded) {
    if (loaded === true) {
      return <h3 style={{ textAlign: 'center', background: '#fafafa', border: '1px solid #e8e8e8', padding: 5 }}>{this.props.photoList.length} Photos</h3>
    } else {
      return <h3 style={{ textAlign: 'center', background: '#fafafa', border: '1px solid #e8e8e8', padding: 5 }}>{this.state.loadedAmount} Photos loaded</h3>
    }
  }

  render() {
    return (
      <div>
        {this.loadedStatus(this.state.loaded)}
        {this.Gallery()}
        <Modal
          title={this.state.selectedPhoto.img_data.client_job_number}
          visible={this.state.modalVisible}
          onOk={this.handleOk}
          onCancel={this.handleOk}
          footer={[
            <Button key="back" onClick={this.handleOk}>Return</Button>,
          ]}
          width={800}

        >
          <Table dataSource={[this.state.selectedPhoto.img_data]} columns={[{
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: date => {
              return moment(date).format('LLLL')
            }
          }, {
            title: 'Latitude',
            dataIndex: 'lat',
            key: 'lat',
          }, {
            title: 'Longitude',
            dataIndex: 'lng',
            key: 'lng',
          }]} pagination={false} />
          <br />
          <img src={this.state.selectedPhoto.img_data.original} alt='' style={{ width: '100%' }} />
        </Modal>
      </div>
    )
  }
}
